export class GlobalService {
  static getDocHtml: any = null;
}
